const BACKEND_SERVER_ENDPOINT = process.env.REACT_APP_SERVER_ENDPOINT;

export const USER_ENDPOINT = BACKEND_SERVER_ENDPOINT + "/user";

export const JOB_APP_ENDPOINT = BACKEND_SERVER_ENDPOINT + "/job-application";

export const LOCAL_STORAGE_USER_ID = "job-track-user-id";

export const LOCAL_STORAGE_SORTING_OPTION = "job-track-sorting-option";
